import { useContext } from 'react'
import {
  ActivityLogContext,
  closeEndWorkoutDialogAction,
  closeStartWorkoutDialogAction,
  openEndWorkoutDialogAction,
  openProgramDoneModalAction
} from 'activity/ducks/index'
import DailyCache from 'common/utils/DailyCache'

export default function useEndWorkoutDialog() {
  const { state, dispatch } = useContext(ActivityLogContext)

  const cachedSessionActivities = new DailyCache('sessionActivities')

  const closeEndWorkoutDialog = () => {
    dispatch(closeEndWorkoutDialogAction())
  }
  const openEndWorkoutDialog = () => {
    dispatch(openEndWorkoutDialogAction())
  }

  const endWorkout = () => {
    dispatch(closeStartWorkoutDialogAction())
    closeEndWorkoutDialog()
    const cacheArray = Object.keys(cachedSessionActivities.cache)
    if (cacheArray){
      const cachedRPE = cacheArray.filter(item => item.includes('RPE'))
      if (cachedRPE.length === 0) {
        dispatch(openProgramDoneModalAction())
      }
    }
  }

  const { endWorkoutDialog } = state.programDialog

  return {
    closeEndWorkoutDialog,
    openEndWorkoutDialog,
    endWorkoutDialog,
    endWorkout
  }
}
